// Import model
import { FilterEstimateRequest } from '../models/FilterEstimateRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { EstimateCondition } from '../models/EstimateCondition';
import { EstimateFields } from '../models/EstimateFields';
import { EstimateIndexedFields } from '../models/EstimateIndexedFields';

// Import dependency serializers (for complex types)
import { EstimateConditionSerializer } from './EstimateConditionSerializer';
import { EstimateFieldsSerializer } from './EstimateFieldsSerializer';
import { EstimateIndexedFieldsSerializer } from './EstimateIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterEstimateRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterEstimateRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterEstimateRequest instance
   */
  static deserialize(json: string): FilterEstimateRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterEstimateRequest instance
   */
  static fromObject(obj: any): FilterEstimateRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterEstimateRequest');
    }


    const instance: FilterEstimateRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as EstimateIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as EstimateFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        EstimateConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterEstimateRequest instances
   */
  static deserializeArray(json: string): FilterEstimateRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterEstimateRequest instance to a JSON string
   */
  static serialize(instance: FilterEstimateRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterEstimateRequest instance to a plain object
   */
  static toObject(instance: FilterEstimateRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        EstimateConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterEstimateRequest instances to a JSON string
   */
  static serializeArray(instances: FilterEstimateRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
